import { render, staticRenderFns } from "./SupplierTabs.vue?vue&type=template&id=38daae74&"
import script from "./SupplierTabs.vue?vue&type=script&lang=js&"
export * from "./SupplierTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports